<template>
  <div class="slds-text-heading_medium slds-text-align_center">
    {{$t('general.logoutOk')}}
  </div>
</template>
<script>
import { dropDb } from '../components/utils/indexedDbUtils'
export default {
  async beforeCreate () {
    dropDb()
    localStorage.removeItem('ACCESS_TOKEN')
    localStorage.removeItem('EMPTY_CONFIG_DATE')
    //localStorage.removeItem('MVS_DATE')
    //localStorage.removeItem('DEALERS_MAP_DATE')
  }
}
</script>
